import * as React from 'react';
import { AppVoiceRecorderProps } from './AppVoiceRecorder.props';
import { AppButton, getSecondaryButtonStyles, getSecondaryButtonOverrideStyles } from '../AppButton';
import { getAppVoiceRecorderStyles, getAppVoiceRecorderStylesv2} from './AppVoiceRecorder.styles';
import { Label, Spinner, SpinnerType, Dialog,  DialogFooter } from 'office-ui-fabric-react';
import { FormatTimeDescription, FormatTime } from '../../utils';
import { AppMicWidget } from './AppMicWidget';
import { AppMicWidgetRecorderState } from './AppMicWidget/AppMicWidget.props';
import { HostAppSettings, HostAppSettingName } from '../../../backend/office-js/HostAppSettings';
import { getDialogContentProps, getDialogStyles, getModalProps, getTopLabelStyles } from '../../common/styles/Popup.styles';
import { AppLayoutSettings } from '../../common/styles/common.styles';

interface AppVoiceRecorderState {
  isPaused: boolean;
  isRecordingCompleted: boolean;
  recordingTime: number;
  shouldShowCancelDialog: boolean;
}

export class AppVoiceRecorder extends React.PureComponent<AppVoiceRecorderProps, AppVoiceRecorderState> {
  private intervalID: number | null = null;

  constructor(props: AppVoiceRecorderProps) {
    super(props);

    this.state = {
      isPaused: false,
      isRecordingCompleted: false,
      recordingTime: 0,
      shouldShowCancelDialog: false
    };

    if (props.isEnabled) {
      this.StartRecordingTimer();
    }
  }

  public componentWillUnmount() {
    window.clearInterval(this.intervalID!);
  }

  public componentDidUpdate(prevProps: AppVoiceRecorderProps) {
    if (this.props.isEnabled && !prevProps.isEnabled) {
      this.StartRecordingTimer();
    }

    if (!this.props.isEnabled && prevProps.isEnabled) {
      this.StopRecordingTimer();
    }
  }

  public render() {
    const { isPaused, isRecordingCompleted, recordingTime, shouldShowCancelDialog } = this.state;
    const { recordingStatusLabel, stopRecordingButtonLabel, isEnabled } = this.props;
    let styles = getAppVoiceRecorderStyles();

    const isTranscriptionNewFlowEnabled = HostAppSettings.IsSettingTrue(HostAppSettingName.IsTranscriptionNewFlowEnabled);
    if(isTranscriptionNewFlowEnabled) {
      styles = getAppVoiceRecorderStylesv2()
    }

    return (
      <div className={styles.root}>
        {!isRecordingCompleted ? <React.Fragment>
          <Label aria-label={FormatTimeDescription(recordingTime, true /* show seconds */)} className={styles.timer}>{FormatTime(recordingTime)}</Label>
          <div className={styles.micWidgetContainer}>
            <AppMicWidget type={'AppMicWidgetProps'} isEnabled={isEnabled} currentMicState={isPaused ? AppMicWidgetRecorderState.Paused : AppMicWidgetRecorderState.Recording} onMicWidgetClicked={this._onPauseResumeButtonClicked} />
          </div>
          {recordingStatusLabel ?
            <div className={styles.statusLabelContainer}>
              <Label id="RecordingStatusLabel" className={styles.statusLabel}>{recordingStatusLabel}</Label>
            </div> : null}
          {isEnabled ?
            <div className={styles.buttonContainer}>
              <AppButton id={'StopRecordingButton'} disabled={isRecordingCompleted} type={'AppButtonProps'} text={stopRecordingButtonLabel} onExecute={this._onStopRecordingClicked} />
            </div> : null}

            {isTranscriptionNewFlowEnabled && isEnabled ?
            <div className={styles.cancelButtonContainer}>
              <AppButton styles={getSecondaryButtonStyles()} id={'CancelButton'} type={'AppButtonProps'} text={'Cancel'} onExecute={this._onCancelButtonClicked} />
            </div> : null}

            {shouldShowCancelDialog ? this.showCancelDialog() : null}

        </React.Fragment>
          : <Spinner type={SpinnerType.large} />}
      </div>
    );
  }

  private StartRecordingTimer() {
    this.intervalID = window.setInterval(
      () => {
        this.setState({ recordingTime: this.state.recordingTime + 1 })
      },
      1000);
  }

  private StopRecordingTimer() {
    window.clearInterval(this.intervalID!);
  }

  private _onPauseResumeButtonClicked = async (): Promise<void> => {
    if (!this.props.isEnabled)
      return;

    const { isPaused } = this.state;

    if (this.props.onRecordingStatusChange) {
      this.props.onRecordingStatusChange(!isPaused);
    }

    if (!isPaused) {
      this.StopRecordingTimer();
    } else {
      this.StartRecordingTimer();
    }

    this.setState({ isPaused: !isPaused });
  };

  private _onStopRecordingClicked = (): void => {
    this.setState({ isRecordingCompleted: true });
    this.props.onRecordingStop();
  };

  private _onCancelButtonClicked = (): void => {
    this.setState({ shouldShowCancelDialog: true });
  }

  // TODO: change strings when finalised from UX
  private showCancelDialog() {
    const cancelDialogTitle: JSX.Element =
    <Label styles={getTopLabelStyles()}>
      Are you sure you want to exit transcription?
    </Label>

    return <Dialog
      dialogContentProps={getDialogContentProps(cancelDialogTitle)}
      modalProps={getModalProps()}
      hidden={!this.state.shouldShowCancelDialog}
      styles={getDialogStyles()}>
      <Label styles={AppLayoutSettings.AppCommonStyles.getPageTopLabelStyles()}>Closing this pane will pause recording.</Label>
      <DialogFooter>
        <AppButton
          type={'AppButtonProps'}
          id="ExitWithoutSavingButtonID"
          styles={getSecondaryButtonOverrideStyles()}
          text='Exit without saving'
          onExecute={this.onExitWithoutSavingButtonClick}
        />
        <AppButton
          type={'AppButtonProps'}
          id="SaveandTranscribeButtonID"
          text='Save and Transcribe'
          onExecute={this.onSaveAndTranscribeButtonClick}
        />
      </DialogFooter>
    </Dialog>
  }

  // TODO: confirm from designer on redirections
  private onExitWithoutSavingButtonClick = () => {
    this.setState({ shouldShowCancelDialog: false });
  }

  // TODO: confirm from designer on redirections
  private onSaveAndTranscribeButtonClick = () => {
    this.setState({ shouldShowCancelDialog: false });
    this._onStopRecordingClicked();
  }
}